/* eslint-disable no-unused-vars */
import { useIntl } from 'react-intl';
import { ApiBulkSession, ApiBulkUploadResultState, ApiBulkUploadStatus } from '@agunity/api-v4';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';

import { AgColor } from '../../../stories/Styles/AgColor';

import * as S from './styled';

const CountTable = ({ details }: { details: ApiBulkSession }) => {
  const formatMessage = useIntl().formatMessage;

  const headers = [{
    field: 'type',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT_TABLE_TYPE' }),
  },
  {
    field: 'total',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT_TABLE_TOTAL' }),
    width: 80,
  },
  {
    field: 'processed',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT_TABLE_PROCESSED' }),
    width: 80,
  },
  {
    field: 'failed',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT_TABLE_FAILED' }),
    width: 80,
  }];

  const totalErrors = details?.errorsCount || 0;
  const isFailedOrNone = [
    ApiBulkUploadResultState.Failed,
    ApiBulkUploadResultState.FailedValidate,
    ApiBulkUploadResultState.None,
  ].includes(details?.resultState!);
  const isCompleted = details?.state === ApiBulkUploadStatus.Completed;
  const shouldProcess = isCompleted && !isFailedOrNone;

  const orgProcessed = shouldProcess ? (details?.orgCount || 0) - totalErrors : 0;
  const staffProcessed = shouldProcess ? (details?.staffCount || 0) - totalErrors : 0;
  const memberProcessed = shouldProcess ? (details?.memberCount || 0) - totalErrors : 0;

  return (
    <TableContainer>
      <Table sx={{ borderTop: `1px solid ${AgColor.grey4}`, borderLeft: `1px solid ${AgColor.grey4}`, }}>
        <TableHead>
          <TableRow>
            {
              headers?.map((header) => (
                <S.StyledTableCell key={header.field} width={header.width}>{header.headerName || ''}</S.StyledTableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {details?.orgCount ? (
            <TableRow>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{formatMessage({ id: 'BULK_UPLOAD_REQUEST_ORGANIZATIONS' })}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{details?.orgCount}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{orgProcessed}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{totalErrors}</S.StyledTableCell>
            </TableRow>
          ) : null}
          {details?.staffCount ? (
            <TableRow>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{formatMessage({ id: 'BULK_UPLOAD_REQUEST_STAFF' })}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{details?.staffCount}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{staffProcessed}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{totalErrors}</S.StyledTableCell>
            </TableRow>
          ) : null}
          {details?.memberCount ? (
            <TableRow>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{formatMessage({ id: 'BULK_UPLOAD_REQUEST_MEMBERS' })}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{details?.memberCount}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{memberProcessed}</S.StyledTableCell>
              <S.StyledTableCell style={{ textAlign: 'left' }}>{totalErrors}</S.StyledTableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CountTable;